(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-handler/common/create-competition-handler-base.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-handler/common/create-competition-handler-base.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
let createCompetitionModel;
let isCompetitionModel;
let logger;
let drawHandler;
let DrawState;
let utils;
let constants;

if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  const _createCompetitionModel = require('./create-competition-model.es6');
  createCompetitionModel = _createCompetitionModel.createCompetitionModel;
  isCompetitionModel = _createCompetitionModel.isCompetitionModel;
  logger = require('../server/logger');
  drawHandler = trinidad.components.require('sport', 'draw-handler').api;
  DrawState = require('../../../sport/tipsen-shared/assets/javascripts/tipsen-shared.es6').DrawState;
  utils = require('../utils.es6');
  constants = require('./constants.es6');
} else {
  const _createCompetitionModel = svs.components.marketplaceCompetition.competitionHandler.common;
  createCompetitionModel = _createCompetitionModel.createCompetitionModel;
  isCompetitionModel = _createCompetitionModel.isCompetitionModel;
  logger = svs.components.marketplaceCompetition.competitionHandler.client.logger;
  drawHandler = svs.components.sport.drawHandler.drawHandler;
  DrawState = svs.components.sport.tipsenShared.DrawState;
  utils = svs.components.marketplaceCompetition.competitionHandler.utils;
  constants = svs.components.marketplaceCompetition.competitionHandler.common.constants;
}
const {
  competitionCacheTime,
  competitionBackendState
} = constants;
const {
  filterUniqueProducts
} = utils;
const constructCompetitionMultifetch = competitionIds => {
  const competitionUrl = competitionIds.map(competitionId => "/competition/1/competitions/".concat(competitionId));
  return "/multifetch?serial=true&urls=".concat(competitionUrl.join('|'));
};
const createModelCollection = () => {
  const competitionTable = new Map();
  const models = new Map();
  const addModel = competition => {
    const competitionModel = createCompetitionModel();
    competitionModel.setData(competition);
    if (!isCompetitionModel(competitionModel)) {
      throw new Error('Competition model must be provided');
    }
    const productId = competitionModel.getProductId();
    const competitionId = competitionModel.getCompetitionId();
    if (models.get(competitionId)) {
      throw new Error("Competition already exists: ".concat(competitionId));
    }
    models.set(competitionId, competitionModel);
    const productCompetitions = competitionTable.get(productId) || [];
    competitionTable.set(productId, productCompetitions.concat(competitionId));
    return competitionModel;
  };
  const setModel = competitionModel => {
    if (!isCompetitionModel(competitionModel)) {
      throw new Error('Competition model must be provided');
    }
    models.set(competitionModel.getCompetitionId(), competitionModel);
  };
  const getCollection = () => models;
  const getModel = competitionId => models.get(competitionId);
  const getSerializeModel = () => ({
    competitions: Object.fromEntries(models.entries()),
    productRelationsTable: Object.fromEntries(competitionTable)
  });
  const hasProduct = productId => competitionTable.has(productId);
  const hasCompetition = competitionId => models.has(competitionId);
  const clear = () => {
    competitionTable.clear();
    models.clear();
  };
  return {
    addModel,
    setModel,
    getCollection,
    getSerializeModel,
    getModel,
    hasProduct,
    hasCompetition,
    clear
  };
};
const createSubscriptionModel = (socket, cache) => competitionId => {
  const competition = cache.getModel(competitionId);
  let _currentSubscribedDraw = null;
  let _isSubscribed = false;
  let _unsubscribeFn;
  let _subscriptions = [];
  const handleSocketUpdate = draw => {
    logger.debug("Socket update on competition: ".concat(competitionId));
    competition.updateCompetitionStatus(draw);
    for (const subscription of _subscriptions) {
      subscription(competition);
    }

    if (!competition.isFinished() && draw.getDrawState() === DrawState.Finalized) {
      logger.info("Competition draw finished, set next drawNumber");
      const isLastDrawNum = competition.isLastDrawNumber();
      competition.updateCurrentDrawNumber();
      unsubscribeToSocket();
      if (!isLastDrawNum) {
        subscribeToSocket();
      }
    }
  };
  const subscribeToSocket = () => {
    if (_isSubscribed) {
      return;
    }
    const productId = competition.getProductId();
    const drawNumber = competition.getCurrentDrawNumber();
    _currentSubscribedDraw = drawNumber;
    _unsubscribeFn = socket.subscribe(productId, drawNumber, handleSocketUpdate);
    _isSubscribed = true;
  };
  const unsubscribeToSocket = () => {
    _isSubscribed = false;
    _currentSubscribedDraw = null;
    _unsubscribeFn();
  };
  const add = callback => {
    if (!_isSubscribed) {
      subscribeToSocket();
    }
    _subscriptions.push(callback);
  };
  const remove = callback => {
    _subscriptions = _subscriptions.filter(_callback => _callback !== callback);
    if (!_subscriptions.length) {
      unsubscribeToSocket();
    }
  };
  const unsubscribe = () => {
    _subscriptions.length = 0;
    unsubscribeToSocket();
  };
  return {
    add,
    remove,
    unsubscribe
  };
};
const createSubscriptionHandler = (socket, cache) => {
  const subscriptions = new Map();
  const get = competitionId => {
    let subObj = subscriptions.get(competitionId);
    if (!subObj) {
      subObj = createSubscriptionModel(socket, cache)(competitionId);
      subscriptions.set(competitionId, subObj);
    }
    return subObj;
  };
  const destroy = () => {
    subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
    subscriptions.clear();
  };
  return {
    get,
    destroy
  };
};
const createCompetitionHandlerBase = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  privateInterface.competitionCache = createModelCollection();

  let _cmsCompetitionIds = [];
  const subscriptions = createSubscriptionHandler(drawHandler(), privateInterface.competitionCache);
  const getAndSetCachedCompetitionModel = (competitionData, persist) => {
    let competitionModel;
    if (persist) {
      competitionModel = privateInterface.competitionCache.getModel(competitionData.id);
      if (!competitionModel) {
        competitionModel = privateInterface.competitionCache.addModel(competitionData);
      } else {
        competitionModel.setData(competitionData);
      }
    } else {
      competitionModel = createCompetitionModel();
      competitionModel.setData(competitionData);
    }
    return competitionModel;
  };
  privateInterface.setCmsCompetitionIds = cmsCompetitionIds => {
    _cmsCompetitionIds = cmsCompetitionIds;
  };
  privateInterface.getCmsCompetitionIds = () => _cmsCompetitionIds;
  privateInterface.fetchCompetitions = async function (competitionIds) {
    let {
      persist = true
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const path = constructCompetitionMultifetch(competitionIds);
    const competitionsResponse = await privateInterface.jupiter(path, {
      method: 'GET'
    });
    const models = [];
    for (const [index, competitionId] of Object.entries(competitionIds)) {
      const competitionResponse = competitionsResponse.responses[index];
      if (competitionResponse.error) {
        var _competitionResponse$, _competitionResponse$2;
        logger.warn("Failed to fetch competition: ".concat(competitionId));
        models.push(new Error("Unable to fetch competition: ".concat(competitionId, ". Error: ").concat((_competitionResponse$ = (_competitionResponse$2 = competitionResponse.error) === null || _competitionResponse$2 === void 0 ? void 0 : _competitionResponse$2.message) !== null && _competitionResponse$ !== void 0 ? _competitionResponse$ : '')));
        _cmsCompetitionIds = privateInterface.getCmsCompetitionIds().filter(id => id !== competitionId);
        continue;
      }
      const competitionData = competitionResponse.competition;
      const competitionModel = getAndSetCachedCompetitionModel(competitionData, persist);

      const draw = drawHandler().get(competitionModel.getProductId(), competitionModel.getCurrentDrawNumber());
      competitionModel.updateCompetitionStatus(draw);
      models.push(competitionModel);
    }
    return models;
  };


  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    publicInterface.$getModel = async competitionIds => {
      logger.info("Use of mocked competitions, competitionIds: ".concat(competitionIds));
      const competitionTable = new Map();
      const competitions = await privateInterface.fetchCompetitions(competitionIds, {
        persist: false
      });
      const filteredCompetitions = competitions.filter(competition => !(competition instanceof Error));
      filteredCompetitions.forEach(comp => {
        const productId = comp.getProductId();
        const competitionId = comp.getProductId();
        const productCompetitions = competitionTable.get(productId) || [];
        competitionTable.set(productId, productCompetitions.concat(competitionId));
      });
      const activeCompetitionIds = filterUniqueProducts(filteredCompetitions);
      return {
        competitions: filteredCompetitions,
        productRelationsTable: Object.fromEntries(competitionTable),
        activeCompetitionIds
      };
    };
    publicInterface.getModel = () => _objectSpread(_objectSpread({}, privateInterface.competitionCache.getSerializeModel()), {}, {
      activeCompetitionIds: privateInterface.getCmsCompetitionIds()
    });
    publicInterface.$revalidateCompetitions = async function (competitionIds) {
      let drawNumbers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      const competitionsIdsToRevalidate = [];
      const competitionIdsArray = [].concat(competitionIds);
      for (const compId of competitionIdsArray) {
        const comp = privateInterface.competitionCache.getModel(compId);
        if (!comp) {
          continue;
        }
        const state = comp.getData().details.state;
        if (state === competitionBackendState.DEFINED || state === competitionBackendState.COMPETITION_COMPLETE) {
          continue;
        }
        const isExpiredCache = new Date(comp.getTimestamp()) < new Date(Date.now() - competitionCacheTime);
        if (isExpiredCache) {
          competitionsIdsToRevalidate.push(comp.getCompetitionId());
          continue;
        }
        const isInactiveDraw = !drawNumbers.includes(comp.getCurrentDrawNumber()) && drawNumbers.some(activeDrawNumber => activeDrawNumber > comp.getData().details.firstDrawNumber);
        if (isInactiveDraw) {
          competitionsIdsToRevalidate.push(comp.getCompetitionId());
        }
      }
      if (competitionsIdsToRevalidate.length) {
        await privateInterface.fetchCompetitions(competitionsIdsToRevalidate);
      }
    };
    publicInterface.subscribe = async (competitionId, callback) => {
      await publicInterface.getCompetition(competitionId);
      subscriptions.get(competitionId).add(callback);
      const unsubscribe = () => {
        subscriptions.get(competitionId).remove(callback);
      };
      return unsubscribe;
    };
    publicInterface.getCompetition = async competitionId => {
      const competitionIds = [].concat(competitionId);
      const competitions = [];
      const competitionsToFetch = [];
      const missingCompetitionRetPositions = [];
      competitionIds.forEach((compId, position) => {
        const comp = privateInterface.competitionCache.getModel(compId);
        if (!comp) {
          missingCompetitionRetPositions.push(position);
          competitionsToFetch.push(compId);
        }
        competitions.push(comp);
      });
      if (competitionsToFetch.length) {
        const fetchedCompetitions = await privateInterface.fetchCompetitions(competitionsToFetch);
        fetchedCompetitions.forEach((comp, fetchedPosition) => {
          const insertPosition = missingCompetitionRetPositions[fetchedPosition];
          competitions[insertPosition] = comp;
        });
      }
      if (competitions.length === 1) {
        const [competition] = competitions;
        if (competition instanceof Error) {
          throw competition;
        }
        return competition;
      }
      return competitions;
    };
    publicInterface.getActiveCompetition = productId => {
      const competitionIds = privateInterface.getCmsCompetitionIds();
      const comps = competitionIds.map(compId => privateInterface.competitionCache.getModel(compId));
      return comps.find(comp => (comp === null || comp === void 0 ? void 0 : comp.getProductId()) === productId);
    };
    publicInterface.getActiveCompetitions = () => {
      const competitionIds = privateInterface.getCmsCompetitionIds();
      return competitionIds.map(compId => privateInterface.competitionCache.getModel(compId));
    };
    publicInterface.destroy = () => {
      subscriptions.destroy();
      privateInterface.competitionCache.clear();
    };
    return publicInterface;
  };
};
if (svs.isServer) {
  module.exports = createCompetitionHandlerBase;
} else {
  setGlobal('svs.components.marketplaceCompetition.competitionHandler.common.createCompetitionHandlerBase', createCompetitionHandlerBase);
}

 })(window);